import React from "react";
import { cn } from "@/utils/cn";
import { CreateVoiceIcon } from "@/components/assets/assets";
import { CreateAudioModal } from "@/components/custom-audio";
import { useTranslation } from "react-i18next";

interface CreateVoiceButtonProps {
  className?: string;
  width?: string;
  height?: string;
  textClassName?: string;
  onSubmit?: (audio: Audio) => void;
  /** 生成音频类型，默认 ElevenLabs */
  generateType?: "ElevenLabs" | "Minimax";
}

/** 创建音频按钮 */
const CreateAudioButton: React.FC<CreateVoiceButtonProps> = ({
  className,
  width,
  height,
  textClassName,
  onSubmit,
  generateType = "ElevenLabs",
}) => {
  const { t } = useTranslation();

  return (
    <CreateAudioModal
      trigger={
        <div
          className={cn(
            "flex justify-center h-[76px]",
            "group relative select-none cursor-pointer",
            "bg-white rounded-md border border-dashed border-[#D0D5DD]",
            "hover:border-[#667085]",
            className
          )}
          style={{
            width,
            height,
          }}
        >
          <div className="flex flex-col items-center justify-center">
            <CreateVoiceIcon className="w-7 h-7 mb-1" />
            <span className={cn("text-[#667085] text-base", textClassName)}>
              {t("assets.create_new_voice")}
            </span>
          </div>
        </div>
      }
      onSubmit={onSubmit}
      generateType={generateType}
    />
  );
};

export { CreateAudioButton };
